import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import MessageArea from '@ui-parts/MessageArea';
import Button from '@ui-elements/Button';
import { ROUTES } from '~/constants/routes';

import { PALETTE } from '~/assets/styles/base';

const PasswordResetCompletedBox = styled.div`
  max-width: 480px;
  max-height: 351px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 58px auto 0;
`;

const StyledTaskAltIcon = styled(TaskAltIcon)`
  color: ${PALETTE.text.primary};
  font-size: 4rem;
`;

const LoginButton = styled(Button)`
  margin: 25px auto 20px auto;
`;

const AdminPasswordResetCompleted: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PasswordResetCompletedBox data-testid="uiPages-admin-password-reset-completed">
      <MessageArea
        title={t('adminMessage.password.title')}
        message={t('adminMessage.password.message')}
        desc={t('adminMessage.password.desc')}
        button={
          <LoginButton size="small" color="primary" variant="outlined" href={ROUTES.ADMIN.SIGNIN}>
            {t('adminSignin.login')}
          </LoginButton>
        }
      >
        <StyledTaskAltIcon />
      </MessageArea>
    </PasswordResetCompletedBox>
  );
};

export default AdminPasswordResetCompleted;
